import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from './AppContext';
import './CollectionsGrid.css';

const CollectionsGrid = () => {
  const { products, lang } = useContext(AppContext);
  const isMr = lang === 'mr';
  const navigate = useNavigate();

  const getCategoryCount = (subCat, category) => {
    return (products || []).filter(p =>
      (p.subCategory === subCat || p.forWhom === (subCat === 'For Women' ? 'For Her' : 'For Him')) &&
      p.category?.toLowerCase().includes(category.toLowerCase())
    ).length;
  };

  const getCategoryImage = (subCat, category, fallback) => {
    const found = (products || []).find(p =>
      (p.subCategory === subCat || p.forWhom === (subCat === 'For Women' ? 'For Her' : 'For Him')) &&
      p.category?.toLowerCase().includes(category.toLowerCase())
    );
    return found?.image || fallback;
  };

  const collections = [
    {
      title: isMr ? 'महिलांच्या अंगठ्या' : "Women's Rings",
      count: `${getCategoryCount('For Women', 'Rings') || 5} ${isMr ? 'स्टाईल्स' : 'Styles'}`,
      img: getCategoryImage('For Women', 'Rings', '/images/w ring1.jpg'),
      tag: isMr ? 'महिला' : 'Women',
      span: 'normal',
      subCat: 'For Women',
      category: 'Rings'
    },
    {
      title: isMr ? 'महिलांच्या चेन्स' : "Women's Chains",
      count: `${getCategoryCount('For Women', 'Chains') || 8} ${isMr ? 'स्टाईल्स' : 'Styles'}`,
      img: getCategoryImage('For Women', 'Chains', '/images/w chain14.jpg'),
      tag: isMr ? 'महिला' : 'Women',
      span: 'tall',
      subCat: 'For Women',
      category: 'Chains'
    },
    {
      title: isMr ? 'कंबरपट्ट्या' : 'Waist Chains',
      count: `${getCategoryCount('For Women', 'Mekhala') || 4} ${isMr ? 'स्टाईल्स' : 'Styles'}`,
      img: getCategoryImage('For Women', 'Mekhala', '/images/waist19.jpg'),
      tag: isMr ? 'महिला' : 'Women',
      span: 'normal',
      subCat: 'For Women',
      category: 'Mekhala (Waist Belt)'
    },
    {
      title: isMr ? 'पुरुषांच्या चेन्स' : "Men's Chains",
      count: `${getCategoryCount('For Men', 'Chains') || 6} ${isMr ? 'स्टाईल्स' : 'Styles'}`,
      img: getCategoryImage('For Men', 'Chains', '/images/men chain5.jpg'),
      tag: isMr ? 'पुरुष' : 'Men',
      span: 'wide',
      subCat: 'For Men',
      category: 'Chains'
    },
    {
      title: isMr ? 'पुरुषांच्या अंगठ्या' : "Men's Rings",
      count: `${getCategoryCount('For Men', 'Rings') || 5} ${isMr ? 'स्टाईल्स' : 'Styles'}`,
      img: getCategoryImage('For Men', 'Rings', '/images/men ring2.jpg'),
      tag: isMr ? 'पुरुष' : 'Men',
      span: 'normal',
      subCat: 'For Men',
      category: 'Rings'
    },
    {
      title: isMr ? 'पैंजण / अँकलेट्स' : 'Payal & Anklets',
      count: `${getCategoryCount('For Women', 'Payal') || 8} ${isMr ? 'स्टाईल्स' : 'Styles'}`,
      img: getCategoryImage('For Women', 'Payal', '/images/painjan.jpg'),
      tag: isMr ? 'महिला' : 'Women',
      span: 'normal',
      subCat: 'For Women',
      category: 'Payal (Anklets)'
    },
    {
      title: isMr ? 'महिलांचे ब्रेसलेट्स' : "Women's Bracelets",
      count: `${getCategoryCount('For Women', 'Bracelets') || 6} ${isMr ? 'स्टाईल्स' : 'Styles'}`,
      img: getCategoryImage('For Women', 'Bracelets', '/images/w br14.jpg'),
      tag: isMr ? 'महिला' : 'Women',
      span: 'normal',
      subCat: 'For Women',
      category: 'Bracelets'
    },
    {
      title: isMr ? 'पुरुषांचे ब्रेसलेट्स' : "Men's Bracelets",
      count: `${getCategoryCount('For Men', 'Bracelets') || 5} ${isMr ? 'स्टाईल्स' : 'Styles'}`,
      img: getCategoryImage('For Men', 'Bracelets', '/images/men br8.jpg'),
      tag: isMr ? 'पुरुष' : 'Men',
      span: 'normal',
      subCat: 'For Men',
      category: 'Bracelets'
    },
  ];

  return (
    <section className="collections-grid-section" id="collections">
      <div className="collections-header reveal">
        <h2 className="section-title">
          {isMr ? 'संपूर्ण' : 'Complete'} <span className="title-italic">{isMr ? 'चांदी' : 'Silver'}</span> {isMr ? 'रेंज' : 'Range'}
        </h2>
        <div className="title-ornament">
          <span /><span className="ornament-diamond">◆</span><span />
        </div>
      </div>

      <div className="cg-mosaic">
        {collections.map((col, i) => (
          <div
            key={i}
            className={`cg-item cg-${col.span} reveal delay-${(i % 3) + 1}`}
            onClick={() => navigate(`/products?category=${encodeURIComponent(col.subCat)}&subcategory=${encodeURIComponent(col.category)}`)}
            style={{ cursor: 'pointer' }}
          >
            <div className="cg-img-wrap">
              <img src={col.img} alt={col.title} onError={(e) => { e.currentTarget.src = '/images/w ring1.jpg'; }} />
              <div className="cg-gradient" />
            </div>
            <div className="cg-info">
              <span className="cg-tag">{col.tag}</span>
              <h3 className="cg-title">{col.title}</h3>
              <span className="cg-count">{col.count}</span>
              <button className="cg-btn">{isMr ? 'पहा →' : 'Explore →'}</button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CollectionsGrid;
